namespace $ {
	export class $shm_hitalama_guide_markdown extends $mol_object {
		static text( page: $shm_hitalama_guide_document_data ) {
			const body = /^#\s+/m.test( page.body ) ? page.body : '# ' + page.title + '\n\n' + page.body
			return body + (page.links.length ? '\n\n' + page.links.map(link=> '- [' + link.title.replace(/[\[\]]/g,'') + '](' + link.page + '.md)').join('\n') : '')
		}
		static page_id( uri: string ) { return /^(?:\.\/)?([a-z0-9]+(?:-[a-z0-9]+)*)\.md(?:#[^]*)?$/.exec(uri)?.[1] ?? '' }
		static references( body: string ) {
			const ids = new Set<string>()
			const visit = (text: string)=> { for(const token of this.$.$mol_syntax_md_line.tokenize(text)) {
				if(token.name==='text-link') { const id=this.page_id(token.chunks[1]);if(id)ids.add(id) }
				else if(['strong','emphasis','strike'].includes(token.name))visit(token.chunks[0])
			} }
			for(const token of this.$.$mol_syntax_md_flow.tokenize(body))if(token.name!=='code')visit(token.found)
			return [...ids]
		}
	}
}
